import React from "react";
import LegalLayout from "./LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" seoKey="privacy-policy">
      <p>Gulfudaan ("we", "us", "our") is committed to protecting the privacy of our customers. This Privacy Policy explains how we collect, use, and safeguard your personal information when you use our website and services.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Information We Collect</h3>
      <p>We collect personal information such as your name, contact number, email address, passport details, and uploaded documents necessary to process GAMCA appointments, visa services, ticket bookings, and related services.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">How We Use Your Information</h3>
      <p>Your information is used solely to process your application, communicate application status, process payments, and provide customer support. We do not sell your personal data to third parties.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Data Security</h3>
      <p>We implement industry-standard security measures including SSL encryption and secure file storage to protect your personal data and uploaded documents from unauthorized access.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Contact Us</h3>
      <p>For any privacy-related concerns, please contact us at help@gulfudaan.com or call +91 73143 44673.</p>
      <p className="text-sm pt-4">Ground Floor, Classic Ashiyana II, Nazarbagh, Lucknow - 226001, Uttar Pradesh, India</p>
    </LegalLayout>
  );
}
